import { secureFetch, secureDownload } from './authService';
import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from './constants';

export function getApps(query) {
	let url = API_BASE_URL + '/apps/mobileapps';
	if (query) {
		url = API_BASE_URL + `/apps/mobileapps?limit=${query.limit || PAGINATION_DEFAULT_LIMIT}&page=${query.page || 0}`;
	}
	return secureFetch(url, {
		method: 'GET'
	});
	//return Promise.resolve({"data":[{"id":1,"name":"versionCode","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":[],"xpathMapping":"string(.//manifest/@versionCode)"},{"id":3,"name":"targetSdkVersion","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":[],"xpathMapping":"string(.//manifest/uses-sdk/@targetSdkVersion)"},{"id":2,"name":"minSdkVersion","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":[],"xpathMapping":"string(.//manifest/uses-sdk/@minSdkVersion)"},{"id":100,"name":"testAttr","type":"APK","valueType":"STRING","defaultValue":"","permittedValues":["val_1","val_2","val_3"],"xpathMapping":""}]})
}

export function uploadApk(data) {

	// return Promise.all(data.map( file => {
	// 	return secureFetch(API_UPLOAD_URL + '/apps/apks/upload', {
	// 			method: 'POST',
	// 			body: file
	// 		}, {});
	// 		})
	// 		.then(responses =>
	// 			Promise.all(responses.map(res => res))
	// 		).then(res => {
	// 			console.log(res);
	// 		}));

	return secureFetch(API_UPLOAD_URL + '/apps/apks/upload', {
		method: 'POST',
		body: data
	}, {});

	// const uploadPromises = []
	//
	// // loop through each file and upload individually
	// Array.from(fileUploadElem.files).forEach((file) => {
	// 	const uploadPromise = new Promise((resolve,reject) => {
	//
	// 		// create FormData object - add file and form fields manually
	// 		const formData = new FormData()
	// 		formData.append('fileUpload', file)
	//
	// 		// dispatch xhr to start file upload - detect file upload completion and notify user
	// 		let xhr = new XMLHttpRequest()
	// 		xhr.onload = () => {
	// 			if (xhr.readyState === 4 && xhr.status === 200) resolve()
	// 			else reject()
	// 		}
	//
	// 		// initiate AJAX request
	// 		xhr.open("POST", formElem.action)
	// 		xhr.send(formData)
	//
	// 	})
	// 	uploadPromises.push(uploadPromise)
	// })

	// add notification when all uploads complete
	// Promise.all(uploadPromises).then(
	// 	() => alert('Upload completed successfully!') ,
	// 	() => alert('Error during file upload.') ,
	// )
}

export function getSingleApp(appId) {
	return secureFetch(API_BASE_URL + '/apps/mobileapps/' + appId, {
		method: 'GET'
	});
}

export function getSingleAppFromGlobalMarket(packageName) {
	return secureFetch(API_BASE_URL + `/apps/mobileapps/?packageName=${packageName}`, {
		method: 'GET'
	});
}

export function downloadApk(appId) { //api/retail/market/57/downloadApk/616
	return secureDownload(API_UPLOAD_URL + '/apps/apks/download/' + appId, {
		method: 'GET',
	});
}

export function deleteApk(apkId) {
	return secureDownload(API_BASE_URL + '/apps/apks/' + apkId, {
		method: 'DELETE',
	});
}

export function selectActiveApk(apkId, retailItemId) {
	return secureDownload(API_BASE_URL + `/retail/market/${retailItemId}/checkedApkIds`, {
		method: 'PUT',
		body: JSON.stringify(apkId)
	});
}

export function updateMobileApp(app) {
    return secureDownload(API_BASE_URL + `/apps/mobileapps/${app.id}`, {
        method: 'PUT',
        body: JSON.stringify({
			visibleForCompanies: app.visibleForCompanies,
			operatorId: app.operatorId
        })
    });
}

export function deleteApp(appId) {
	return secureDownload(API_BASE_URL + '/apps/mobileapps/' + appId, {
		method: 'DELETE',
	});
}

export function getCheckedAppsInfo(apps) {
	return secureFetch(API_BASE_URL + '/apps/mobileapps/batch', {
		method: 'POST',
		body: JSON.stringify({
            mobileAppIds: apps
		})
	});
}

/* Work with retail market data */

export function getInRetailCheckedApps(companyId, packageNames) {
	const data = {
		companyId,
		packageNames
	};
	return secureFetch(API_BASE_URL + '/retail/market/packageName/batch', {
		method: 'POST',
		body: JSON.stringify(data)
	});
}

export function saveInRetailCheckedApps(companyId, mobileAppIds) {
	const data = {
		companyId,
		mobileAppIds
	};
	return secureFetch(API_BASE_URL + '/retail/market', {
		method: 'POST',
		body: JSON.stringify(data)
	});
}



// WEBPACK FOOTER //
// ./src/helpers/marketService.js